import { PaginationOptions } from './../../../@resources/graphql/types/types';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HealthEducation } from 'src/app/@resources/graphql/types/types';
import { HealthEducationService } from 'src/app/@resources/services/health-education.service';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';
import { SeoService } from '../../../@resources/services/SEO.service';
import AOS from 'aos';

@Component({
  selector: 'app-health-education-details',
  templateUrl: './health-education-details.component.html',
  styleUrls: ['./health-education-details.component.scss'],
})
export class HealthEducationDetailsComponent implements OnInit {
  healthEducation: HealthEducation;
  healthEducationId: any;
  paginationOptions: PaginationOptions = { limit: 3, page: 1 };
  healtEducationsByCategory: HealthEducation[];
  lang: string;
  constructor(
    private route: ActivatedRoute,
    private healthEducationService: HealthEducationService,
    private readonly seoService: SeoService,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    AOS.init();
    this.healthEducationId =
      this.route.snapshot.paramMap.get('healthEducationId');
    this.listHealthEducation();
  }
  listHealthEducation() {
    this.healthEducationService
      .healthEducation({ healthEducationId: this.healthEducationId })
      .subscribe((res: any) => {
        this.healthEducation = res.data.healthEducation;
        this.listHealthEducationByCategory(
          this.healthEducation?.healthEducationCategoryId
        );
        this.lang = this.localStorage.get('lang');
        this.lang == 'ar'
          ? this.seoService.updateTitle(this.healthEducation?.titleAr)
          : this.seoService.updateTitle(this.healthEducation?.title);
      });
  }

  listHealthEducationByCategory(categoryId: any) {
    this.healthEducationService
      .healthEducationByCategory({
        pagination: this.paginationOptions,
        categoryId: categoryId,
      })
      .subscribe((res: any) => {
        this.healtEducationsByCategory = [
          ...res?.data?.healthEducationsByCategory,
        ];
      });
  }
}
